import { ChannelHint } from "@/types/chat-external-message";

type Translate = (key: string, opts?: Record<string, string>) => string;

export const labelForHint = (hint: ChannelHint, t: Translate): string => {
  if (hint === "auto") return t("communicationChannels.composer.picker.auto");
  if (hint === "STREAM") {
    return t("communicationChannels.composer.picker.stream");
  }
  return t(`communicationChannels.channels.${hint}.label`);
};
